import React, {useContext} from 'react';
import UserContext from '../components/common/UserContext.js';

// css
import '../assets/css/Help.css';

// reactstrap
import {Col, Row} from 'reactstrap';

// components
import PageHeader from '../components/common/PageHeader.js';
import HelpMenu from '../components/Help/HelpMenu.js';
import {toHtml} from '../components/common/utilities.js';

// images
import KSMSADownloadArrowButton from '../assets/img/Help/ksm-sa-arrow-button.png';
import KSMSADownloadHomeButton from '../assets/img/Help/ksm-sa-home-button.png';
import KSMSADownloadButton from '../assets/img/Help/ksm-sa-download-button.png';
import KSMSADownloadMyLicenses from '../assets/img/Help/ksm-sa-download-my-licenses.png';

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {Text} from '../components/common/MultilingualText.js';
import {
    aboutSoftwareAccessKey,
    helpSAAboutSectionKey,
    mainMessages,
    viewDownloadLicensesKey,
    stepsToViewDownloadLicensesKey,
    navigationKey,
    helpSADownloadStepsSectionKey,
    helpSANavigationSectionKey,
} from '../assets/text/MultilingualText.js';

function SADownloadHelp(props) {
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    function OrderedListItem({item}) {
        let children = null;
        let type = item.substeps && item.substeps[0] ? item.substeps[0].type : 1;

        let img;
        let imgInlineStyle = (item.img === "ksm-sa-arrow-button" ||
            item.img === "ksm-sa-download-button" ||
            item.img === "ksm-sa-home-button") ? {display: 'flex', alignItems: 'center'} : {};


        if (item.img) {
            switch (item.img) {
                case 'ksm-sa-arrow-button':
                    img = <img src={KSMSADownloadArrowButton} alt={item.img}/>
                    break;
                case 'ksm-sa-download-button':
                    img = <img src={KSMSADownloadButton} alt={item.img}/>
                    break;
                case 'ksm-sa-home-button':
                    img = <img src={KSMSADownloadHomeButton} alt={item.img}/>
                    break;
                case 'ksm-sa-download-my-licenses':
                    img = <img src={KSMSADownloadMyLicenses} alt={item.img}/>
                    break;
                default:
                    img = <></>
                    break;
            }
        }

        if (item.substeps && item.substeps.length) {
            children = type === "bullet" ? <ul style={{listStyleType: 'disc'}}>
                {item.substeps.map(i => (
                    <OrderedListItem item={i} key={i.order}/>
                ))}
            </ul> : <ol type={type}>s
                {item.substeps.map(i => (
                    <OrderedListItem item={i} key={i.order}/>
                ))}
            </ol>;
        }

        if (item.img === "ksm-sa-arrow-button" ||
            item.img === "ksm-sa-download-button" ||
            item.img === "ksm-sa-home-button") {
            return (
                <li>
                    <div style={imgInlineStyle}>
                        {toHtml(item.step_prefix)}
                        {item.img ? <span className="img-container">
                            {img}
                        </span> : <></>}
                        {toHtml(item.step_suffix)}
                    </div>
                    {children}
                </li>
            )
        }

        return (
            <li>
                <div style={imgInlineStyle}>
                    {toHtml(item.step)}
                    {item.img ? <span className="img-container">
                        {img}
                    </span> : <></>}
                </div>
                {children}
            </li>
        );
    }

    const helpContent = {
        'header': {
            key: viewDownloadLicensesKey,
            default: mainMessages[siteLanguageDefault][viewDownloadLicensesKey]
        },
        'topics': [
            {
                key: aboutSoftwareAccessKey,
                default: mainMessages[siteLanguageDefault][aboutSoftwareAccessKey],
                hash: '#about'
            },
            {
                key: stepsToViewDownloadLicensesKey,
                default: mainMessages[siteLanguageDefault][stepsToViewDownloadLicensesKey],
                hash: '#steps'
            },
            {
                key: navigationKey,
                default: mainMessages[siteLanguageDefault][navigationKey],
                hash: '#navigation'
            },
        ],
        'faq': [],
    };

    const AboutSectionKey = localization.toLanguageString(
        helpSAAboutSectionKey,
        mainMessages[siteLanguageDefault][helpSAAboutSectionKey]
    );

    const StepsSectionKey = localization.toLanguageString(
        helpSADownloadStepsSectionKey,
        mainMessages[siteLanguageDefault][helpSADownloadStepsSectionKey]
    );

    const NavigationSectionKey = localization.toLanguageString(
        helpSANavigationSectionKey,
        mainMessages[siteLanguageDefault][helpSANavigationSectionKey]
    );



    return (
        <>
            <PageHeader/>
            <div className={"ksm-page-container"}>
                <Row>
                    <Col xs="3">
                        <HelpMenu helpContent={helpContent}/>
                    </Col>
                    <Col xs="9">
                        <div
                            className={"k-h3"}
                            id="about"
                        >
                            <Text
                                textkey={aboutSoftwareAccessKey}
                                textdefault={mainMessages[siteLanguageDefault][aboutSoftwareAccessKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            {AboutSectionKey.section_one}
                            {AboutSectionKey.section_one_bullets ? <ul>
                                {AboutSectionKey.section_one_bullets.map((bullet, index) => <li
                                    key={'sa-about-bullet-' + index}>
                                    {toHtml(bullet)}
                                </li>)}
                            </ul> : <></>}
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="steps"
                        >
                            <Text
                                textkey={stepsToViewDownloadLicensesKey}
                                textdefault={mainMessages[siteLanguageDefault][stepsToViewDownloadLicensesKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            {toHtml(StepsSectionKey.section_one)}
                            <ol type="1">
                                {StepsSectionKey.section_one_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                            </ol>
                            <img src={KSMSADownloadMyLicenses} alt="ksm-sa-download-my-licenses"/>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="navigation"
                        >
                            <Text
                                textkey={navigationKey}
                                textdefault={mainMessages[siteLanguageDefault][navigationKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            {NavigationSectionKey.section_one_steps ? <ul>
                                {NavigationSectionKey.section_one_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                            </ul> : <></>}
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default SADownloadHelp;

